// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'payback', 'payback Fallback'"},"className":"__className_e33842","variable":"__variable_e33842"};